import { ApiResponseError, UnauthorizedError } from '../api';
import { authRevokeURL, authTokenURL } from '../config/NewAPIConfig';

const client_id = 'web_client';

interface ErrorResponse {
    error: string;
    error_description: string;
}

interface SuccessResponse {
    access_token: string;
    token_type: string;
    refresh_token: string;
    expires_in: number;
    scope: string;
}

export type GetTokenParams =
    | {
          grant_type: 'password';
          username: string;
          password: string;
          device_id: string;
      }
    | {
          grant_type: 'refresh_token';
          refresh_token: string;
      };

export interface GetTokenResponse {
    accessToken: { value: string };
    refreshToken: { value: string };
}

export default async function fetchOauthToken(params: GetTokenParams): Promise<GetTokenResponse> {
    const response = await fetch(authTokenURL, {
        method: 'POST',
        body: new URLSearchParams({
            client_id,
            ...params,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    });

    if (!response.ok) {
        if (response.status == 400) {
            const error = await response.json<ErrorResponse>();

            throw new UnauthorizedError(error);
        } else {
            throw new ApiResponseError(response.status, await response.text());
        }
    }

    const token = await response.json<SuccessResponse>();

    return {
        accessToken: {
            value: token.access_token,
        },
        refreshToken: {
            value: token.refresh_token,
        },
    };
}

type RevokeTokenParams = {
    token: string;
    token_type_hint: 'refresh_token' | 'access_token';
};

export async function revokeOauthToken(params: RevokeTokenParams) {
    const response = await fetch(authRevokeURL, {
        method: 'POST',
        body: new URLSearchParams({
            client_id,
            ...params,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    });

    return await response.text();
}
